/* */
import { useEffect } from 'react';

export default (func, target = null, ...dependencies) => {
  if (target) {
    return useEffect(() => {
      const documentElement = document.querySelector(target);
      if (documentElement) {
        documentElement.addEventListener('scroll', func);
        return () => {
          documentElement.removeEventListener('scroll', func);
        };
      }
    }, [...dependencies]);
  } else {
    return useEffect(() => {
      window.addEventListener('scroll', func);
      return () => {
        window.removeEventListener('scroll', func);
      };
    }, [...dependencies]);
  }
};
